function KPI(props) {
  return (
    <>
      {Object.keys(props).length ? (
          <div className="KPI_Card bxShadow" key={props.key}>
            <div className="numeric">
              {" "}
              <div className="first">
                {props?.kpiData?.numeric_title_1}
              </div>{" "}
              <div className="second" style={{ marginLeft:  props?.kpiData?.numeric_title_2.length ? "12px" : "5.5px"}}>{props?.kpiData?.numeric_title_2}</div>
            </div>
            <div className="_text">{props?.kpiData?._title}</div>
            <div className="description">{props?.kpiData?._description}</div>
          </div>
      ) : "" }
    </>
  );
}

export default KPI;
